import { useContext } from 'react';
import { RangeField } from '@zopauk/web-ui';
import { CalculatorContext } from '@/components/Calculator/Context';

export const Range = () => {
  const context = useContext(CalculatorContext);

  if (!context.pricing) {
    return null;
  }

  return (
    <div className="mx-[-12px] mb-6 lg:mx-[-16px]">
      <RangeField
        onChange={(event) => {
          context.setAmount(`${event.currentTarget.value}`, true);
        }}
        data-automation="ZA.input-range"
        value={Number(context.amount)}
        id="calculator-input-range"
        max={context.maximum}
        min={context.minimum}
        label="Amount"
        step={100}
        hideLabel
        controls
      />
    </div>
  );
};
